import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Mode, QuestionType } from '../../app.constant';
import { CommonService } from '../../service/common.service';

@Component({
  selector: 'app-b-textarea',
  templateUrl: './b-textarea.component.html',
  styleUrls: ['./b-textarea.component.css']
})
export class BTextareaComponent implements OnInit {

  @Input() question: any;
  @Input() t_result_list: any[];
  @Input() mode: number;
  @Output() t_result_listChange = new EventEmitter();

  @Input() isEnable: boolean;

  inputText;
  required_flg: boolean;

  MODE: any = Mode;
  Q_TYPE:any = QuestionType;

  constructor(private commonService: CommonService) { }

  ngOnInit() {
    if (this.question.m_question_type_id == this.Q_TYPE.TEXTAREA) {
      this.required_flg = this.commonService.exchange01toTF(this.question.m_question_required_flg);
    } else {
      this.required_flg = this.commonService.exchange01toTF(this.question.m_question_last_text_input_required_flg);
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/parts/b-textarea/b-textarea.component.ts